import $ from 'jquery';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default class Timeline {
    constructor() {
        if($('.js-timeline').length) {
            const swiper = new Swiper('.js-timeline', {
                modules: [
                    Pagination
                ],
                pagination: {
                    clickable: true,
                    el: '.swiper-pagination'
                },
                slidesPerGroup: 1,
                slidesPerView: 1,
                spaceBetween: 0,
                breakpoints: {
                    768: {
                        centerInsufficientSlides: true,
                        slidesPerGroup: 2,
                        slidesPerView: 2
                    },
                    1024: {
                        centerInsufficientSlides: true,
                        slidesPerGroup: 4,
                        slidesPerView: 4
                    }
                }
            });
        };
    };
};
